module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/whatsapp-lg-icon-ca1165c5e20f60b42d4ca00453687291.png";